import { render, staticRenderFns } from "./ResourceSetting.vue?vue&type=template&id=3dff64a4"
import script from "./ResourceSetting.vue?vue&type=script&lang=js"
export * from "./ResourceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports